<div class="table-section">
  <lx-price-lists-portal-table-header title="Studienkolleg preparation" [currency]="currency"></lx-price-lists-portal-table-header>
  <lx-price-lists-portal-price-and-note-table
    [company]="company"
    [dataSource]="dataSource"
    [columnLabels]="columnLabels"
  ></lx-price-lists-portal-price-and-note-table>
</div>
